// src/components/Features.js
import React from "react";
import { Link } from "react-router-dom";  // ✅ Import Link
import "./Feature.css";

function Features() {
  return (
    <section className="container my-5">
      <div className="row text-center">
        {/* Square 1 - Level */}
        <div className="col-md-2">
          <Link to="/level" className="text-decoration-none">
            <div className="feature-box animate delay-1">
              <i className="bi bi-thermometer-half"></i>
              <p>Level</p>
            </div>
          </Link>
        </div>

        {/* Square 2 - Pressure */}
        <div className="col-md-2">
          <Link to="/pressure" className="text-decoration-none">
            <div className="feature-box animate delay-2">
              <i className="bi bi-speedometer2"></i>
              <p>Pressure</p>
            </div>
          </Link>
        </div>

        {/* Square 3 - Flow */}
        <div className="col-md-2">
          <Link to="/flow" className="text-decoration-none">
            <div className="feature-box animate delay-3">
              <i className="bi bi-droplet-half"></i>
              <p>Flow</p>
            </div>
          </Link>
        </div>

        {/* Square 4 - Temperature */}
        <div className="col-md-2">
          <Link to="/temperature" className="text-decoration-none">
            <div className="feature-box animate delay-4">
              <i className="bi bi-thermometer"></i>
              <p>Temperature</p>
            </div>
          </Link>
        </div>

        {/* Square 5 - Analytical */}
        <div className="col-md-2">
          <Link to="/analytical" className="text-decoration-none">
            <div className="feature-box animate delay-5">
              <i className="bi bi-bar-chart-line"></i>
              <p>Analytical</p>
            </div>
          </Link>
        </div>

        {/* Square 6 - Indicator */}
        <div className="col-md-2">
          <Link to="/indicator" className="text-decoration-none">
            <div className="feature-box animate delay-6">
              <i className="bi bi-eye"></i>
              <p>Indicator</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Features;
